/**
 * Thiết lập nguồn dữ liệu cho đơn vị trực thuộc
 */
export default {
  /**
   * Quyết định giao dự toán
   */
  BudgetDecision: 1,
  
  /**
   * Biên bản kiểm tra dự toán
   */
  AuditRecord: 2,
};
